<template>
  <div id="getStarted">
      <div class="splashLogoContainer">
        <img class="splashLogoTop" src="../assets/images/SplashLogoTop.png">
        <img class="splashLogoBottom" src="../assets/images/SplashLogoBottom.png">
      </div>
      <div class="intro">
        <p>Welcome to <a href="https://muster.io/" target="_blank">Muster</a>, the most efficient way to get together.</p>
        <p>Muster uses your phone number as your user ID. Please confirm your phone number and then enter your name to sign in.</p>
        <br/>
        <button v-on:click="getStarted()">Get Started</button>
      </div>
  </div>
</template>

<script>
  export default {
    name: "GetStarted",
    methods: {
      getStarted() {
        console.log(`COUNTRY: ${this.$route.query.country}`)
        console.log(`PHONE: ${this.$route.query.phone}`)
        this.$router.push({ name: 'SignIn', params: { country: this.$route.query.country, phone: this.$route.query.phone } })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GetStarted.vue